import { render, staticRenderFns } from "./TertiaryBtn.vue?vue&type=template&id=f6f7962c"
import script from "./TertiaryBtn.vue?vue&type=script&lang=js"
export * from "./TertiaryBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports